import classNames from "classnames";
import { isEmpty } from "lodash";
import { Button } from "@circle-react-uikit/Button";
import type { ToggleSwitchProps } from "@circle-react-uikit/ToggleSwitchWithLabel";
import { ToggleSwitch } from "@circle-react-uikit/ToggleSwitchWithLabel";
import { Typography } from "@circle-react-uikit/Typography";

export interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  fullWidth?: boolean;
  isFirstChild?: boolean;
  isSubmitDisabled?: boolean;
  onSubmit?: () => void;
  submitButtonText?: string;
  title: string;
  toggleSwitchProps?: Partial<ToggleSwitchProps>;
  variant?: "default" | "fullScreen";
}

export const SectionCard = ({
  children,
  dataTestId,
  onSubmit,
  title,
  submitButtonText,
  isSubmitDisabled,
  fullWidth,
  variant = "default",
  toggleSwitchProps = {},
  className,
  isFirstChild = false,
}: SectionCardProps) => {
  const isDefault = variant === "default";
  return (
    <div
      className={classNames(
        {
          "bg-primary border-primary rounded-lg border px-8 py-6": isDefault,
          "md:w-[624px]": isDefault && !fullWidth,
          "md:w-[720px]": !isDefault,
          "w-full": fullWidth,
        },
        className,
      )}
      data-testid={dataTestId}
    >
      <div className="flex flex-row items-center">
        <div>
          <Typography.TitleSm weight="font-bold">{title}</Typography.TitleSm>
        </div>
        {submitButtonText && (
          <div>
            <Button onClick={onSubmit} disabled={isSubmitDisabled}>
              {submitButtonText}
            </Button>
          </div>
        )}
        {!isEmpty(toggleSwitchProps) && (
          <ToggleSwitch
            field={toggleSwitchProps?.field ?? ""}
            value={toggleSwitchProps?.value ?? false}
            onChange={toggleSwitchProps?.onChange ?? (() => {})}
          />
        )}
      </div>
      <div className={classNames({ "mt-1 md:mt-4": !isFirstChild })}>
        {children}
      </div>
    </div>
  );
};
